import React from 'react'
import { useSelector } from 'react-redux'
import PageResult from '../../../features/search/components/page-result'
import { Featured } from '../../resource/components'

const DetailResource = () => {
  const defaultFeatureds = useSelector(state => state.organization.featured_resources)

  return (
    <PageResult
      customHeader={<></>}
      customNav={<Featured embed={true} defaultItems={defaultFeatureds}/>}
      filterOptions={{
        keyword: true,
        location: false,
        type: true,
        date: true,
        category: false,
        category_resource: true,
        type_resource: true,
      }}
    />
  )
}

export { DetailResource }
